import { useEffect, useMemo } from "react"
import { useLocation, useNavigate } from "react-router"
import { useUser } from "@/apis/bff"
import { subNavigation } from "@/layouts/admin"
import { DefaultLayoutOutlet } from "@/layouts/default-outlet"
import { setDocumentTitle } from "@/lib/environment-title-prefix"
import { useUserStore } from "@/lib/fetch-users"
import { ProductivityCockpit } from "@/modules/productivity-cockpit/productivity-cockpit"
import { WaitingRoomFiltersProvider } from "@/modules/waiting-room/contexts/waiting-room-filters-context"
import { getDoctorLanguagesSkill } from "@/modules/waiting-room/helpers/waiting-room-helper"

const DefaultLayout = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const user = useUser()

  const isAdminRoute = location.pathname.startsWith("/admin")

  useEffect(() => {
    if (!["/admin", "/admin/"].includes(location.pathname)) return

    const firstValidChild = subNavigation.flatMap((sn) => sn.children).find((sn) => user.isOneOf(sn.roles))
    if (firstValidChild) {
      const path = `/admin/${firstValidChild.to}`
      if (location.pathname !== path) {
        navigate(path, { replace: true })
      }
    }
  }, [navigate, user, location.pathname])

  useEffect(() => {
    setDocumentTitle("Sofia")
  }, [])

  return (
    <DefaultLayoutOutlet isAdminRoute={isAdminRoute}>
      <ProductivityCockpit />
    </DefaultLayoutOutlet>
  )
}

const WaitingRoomProvider = () => {
  const user = useUser()
  const loginUser = useUserStore((state) => state.loginUser)
  const doctorLanguages = useMemo(() => {
    return loginUser ? getDoctorLanguagesSkill(loginUser) : null
  }, [loginUser])

  if (!loginUser) {
    return null
  }

  return (
    <WaitingRoomFiltersProvider role={user.role} userName={user.userName} doctorLanguages={doctorLanguages}>
      <DefaultLayout />
    </WaitingRoomFiltersProvider>
  )
}

export { DefaultLayout, WaitingRoomProvider }
